var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Row',[_c('Col',[_c('h4',{staticClass:"text-paragraph-1 font-weight-medium mr-2 mb-2",domProps:{"textContent":_vm._s(_vm.lc.title)}}),_c('p',{class:_vm.grayText},[_vm._v(_vm._s(_vm.lc.description)+" "),_c('span',{staticClass:"d-block"},[_vm._v(_vm._s(_vm.lc.observation))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }